export const APPROVE_RECORD_PROGRESS_INREVIEW = '审批中';
export const APPROVE_RECORD_PROGRESS_COMPLETE = '完成';

export const formatApproveRecordProgress = userType => {
    switch (userType) {
        case APPROVE_RECORD_PROGRESS_INREVIEW:
            return '审批中';
        case APPROVE_RECORD_PROGRESS_COMPLETE:
            return '完成';
        default:
            return '';
    }
};
